import script from "./video.vue?vue&type=script&setup=true&lang=ts"
export * from "./video.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__